<template>
  <v-layout
    row
    wrap
    align-center
  >
    <v-flex
      xs12
      md6
      lg6
    >
      <h6
        class="title text-capitalize"
        v-text="pageTitle ? pageTitle : title"
      />
      <!-- end h6 -->
      <breadcrumbs class="pt-2 pb-0 pl-0 pr-0 text-capitalize" />
      <!-- end breadcrumbs -->
    </v-flex>
    <!-- end flex -->
    <v-flex
      class="hidden-sm-and-down"
      xs12
      md6
      lg6
    >
      <v-layout
        justify-end
      >
        <v-btn
          v-if="hasBackButton"
          flat
          primary
          @click="$router.go(-1)"
        >
          <v-icon left>
            arrow_back
          </v-icon>
          Go back
        </v-btn>
        <!-- end btn -->
        <slot />
        <!-- end slot -->
      </v-layout>
      <!-- end layout -->
    </v-flex>
    <!-- end flex -->
  </v-layout>
  <!-- end layout -->
</template>

<script>
import Breadcrumbs from './Breadcrumbs'
export default {
  components: {
    Breadcrumbs
  },
  props: {
    hasBackButton: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    title () {
      return this.$route.name.replace(/[.]/g , ' ')
    }
  }
}
</script>
